import { largeFileConfig } from '@/core/helpers/axiosHelper';
import { ApiResource } from '@/core/models/ApiResource.interface';
import { LocationQuery } from 'vue-router';
import { CustomerDocument, UploadCustomerDocumentDTO } from './document.interface';

export class DocumentService {
   async getDocuments(customerId: number, params?: LocationQuery) {
      const response = await http.get<ApiResource<Array<CustomerDocument>>>(`/customers/${customerId}/documents`, {
         params,
      });

      return response.data;
   }

   async getDocument() {
      throw Error('Method not implemented');
   }

   async postDocument(customerId: number, data: UploadCustomerDocumentDTO) {
      const formData = new FormData();
      formData.append('customer_document_type_id', data.customer_document_type_id.toString());
      formData.append('name', data.name);
      formData.append('document', data.document);

      const response = await http.post<ApiResource<CustomerDocument>>(`/customers/${customerId}/documents`, formData, largeFileConfig);

      return response.data;
   }

   async putDocument() {
      throw Error('Method not implemented');
   }

   async deleteDocument(customerId: number, documentId: number) {
      const response = await http.delete<ApiResource<CustomerDocument>>(`/customers/${customerId}/documents/${documentId}`);

      return response.data;
   }

   async getDocumentUrls(customerId: number, documentIds: Array<number>) {
      const response = await http.get<ApiResource<Array<CustomerDocument>>>(`/customers/${customerId}/document-urls`, {
         params: { ids: documentIds.join(',') },
      });

      return response.data;
   }
}
